export const COURSE_BUILDER_DRAFT_KEY = "courseBuilderDraft";
export const COURSE_BUILDER_META_KEY = "courseBuilderMeta";
export const COURSE_BUILDER_COURSE_ID_KEY = "courseBuilderCourseId";
export const COURSE_BUILDER_STATE_KEY = "courseBuilderState";
export const AUTH_STATE_KEY = "authState";
export const LOGIN_TIMESTAMP_KEY = "loginTimestamp";
export const CURRENT_COURSE_NAME_KEY = "currentCourseName";
export const ASSESSMENT_ATTEMPT_META_KEY = "assessmentAttemptMeta";
// Session-scoped: the learner's chosen content language on the course overview.
export const COURSE_LANGUAGE_KEY = "courseLanguage";
